<template>
  <div>
    <div>
      <div v-if="loaded && adminReports.length === 0">
        <div class="alert alert-primary" role="alert">گزارشی یافت نشد.</div>
      </div>
    </div>
    <div v-if="loaded && adminReports.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>نوع</th>
                <th>توضیحات</th>
                <th>تاریخ</th>
                <th>header</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="report in adminReports" :key="report.id">
                <td class="text-nowrap">
                  {{ reportTypes[report.type] }}
                </td>
                <td class="text-nowrap">
                  <span class="max-w-200px">{{ report.content }}</span>
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(report.created_at) }}
                </td>
                <td>
                  <pre dir="ltr" class="text-nowrap max-w-200px">
                    {{ report.header }}
                  </pre>
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'admin-programs-show',
                      params: { id: report.program_id }
                    }"
                    class="btn btn-xs btn-outline-primary"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده برنامه
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="adminReportsPagination.lastPage > 1">
      <b-pagination
        v-model="adminReportsPagination.currentPage"
        :total-rows="adminReportsPagination.total"
        :per-page="adminReportsPagination.perPage"
        aria-controls="my-table"
        @input="updateReports()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_ADMIN_REPORTS } from "@/core/services/store/admin/reports.module";
import { mapGetters } from "vuex";

export default {
  name: "admin-reports",
  data() {
    return {
      loaded: false,
      searchType: ""
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "مدیریت",
        route: { name: "admin-dashboard" }
      },
      { title: "گزارشات" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});

    this.updateReports();
  },
  computed: {
    ...mapGetters(["adminReports", "adminReportsPagination", "reportTypes"])
  },
  methods: {
    updateReports() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_REPORTS)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
